import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials = [['“I have my Sundays back. The projects are clear, inspiring, and easy to adapt.”', 'Sarah M.', 'Austin, USA 🇺🇸'], ['“The progression across the year is exactly what my classroom needed.”', 'Ella B.', 'Bristol, UK 🇬🇧'], ['“The low-budget ideas make a real difference in my art room.”', 'Ada O.', 'Lagos, Nigeria 🇳🇬'], ['“The rubrics have made assessment feel calm and genuinely useful.”', 'Maya K.', 'Toronto, Canada 🇨🇦'], ['“A beautiful, practical resource that saves me hours every week.”', 'Sophie L.', 'Melbourne, Australia 🇦🇺'], ['“Every file is so well organised. It feels made by someone who understands teachers.”', 'Tara N.', 'Singapore 🇸🇬']];
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-352">
      <Reveal className="mx-auto max-w-6xl" data-id="element-353">
        <div className="mb-12 text-center" data-id="element-354">
          <h2 className="text-3xl font-black md:text-4xl" data-id="element-355">
            What Teachers Are Saying.
          </h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-356">
            ⭐⭐⭐⭐⭐ 4.9/5 · +2,000 Teachers
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-357">
          {testimonials.map(([quote, name, location]) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-dark p-7" data-id="element-358">
              <div className="flex gap-1" data-id="element-359">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-360" />)}
              </div>
              <p className="mt-5 flex-1 font-serif text-lg italic leading-relaxed" data-id="element-361">
                {quote}
              </p>
              <div className="mt-6" data-id="element-362">
                <p className="text-sm font-bold" data-id="element-363">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-364">{location}</p>
              </div>
            </article>)}
        </div>
        <p className="mt-5 text-center text-xs text-brand-gray" data-id="element-365">
          Illustrative placeholder testimonials.
        </p>
      </Reveal>
    </section>;
}